import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { containers as listTimelineContainers } from '@features/list_timeline/index.js'
import { containers as horizontalTimelineContainers } from '@features/classic_horizontal_timeline/index.ts'
import { TIMELINE, LIST } from '@constants/timeline_view_modes.js'
import { SMALL, MEDIUM, LARGE } from '@constants/timeline_view_sizes.js'

const ADS_CLASS_NAME = 'with-content-ads'

const { ListTimelineContainer } = listTimelineContainers
const { HorizontalTimelineContainer } = horizontalTimelineContainers
import { ThemeContext } from '../../base/ThemeContext'

export default class TimelineSwitcher extends Component {
  constructor(props) {
    super(props)
    this.updateInTimelineAdClass()
  }

  getSnapshotBeforeUpdate() {
    // Note: We must ensure correct class name before comitting the updates to the DOM for Google Ads to be able to render correctly
    this.updateInTimelineAdClass()
    return null
  }
  componentDidUpdate() {
    // to satisfy React console warning as we currently only need getSnapshotBeforeUpdate
  }

  updateInTimelineAdClass() {
    const { viewType } = this.props
    if (viewType === LIST) {
      this.addInTimelineAdClass()
    } else {
      this.removeInTimelineAdClass()
    }
  }

  getBodyEl() {
    return document.getElementsByTagName('body')[0]
  }

  addInTimelineAdClass() {
    const bodyEl = this.getBodyEl()
    if (bodyEl && !bodyEl.classList.contains(ADS_CLASS_NAME)) {
      bodyEl.classList.add(ADS_CLASS_NAME)
    }
  }

  removeInTimelineAdClass() {
    const bodyEl = this.getBodyEl()
    if (bodyEl && bodyEl.classList.contains(ADS_CLASS_NAME)) {
      bodyEl.classList.remove(ADS_CLASS_NAME)
    }
  }

  getListTimelineContent() {
    const { timelineId, environment } = this.props
    return <ListTimelineContainer timelineId={timelineId} environment={environment} />
  }

  getHorizontalTimelineContent() {
    const { timelineId, namespace } = this.props
    return <HorizontalTimelineContainer namespace={namespace} timelineId={timelineId} />
  }

  getContent() {
    const { viewType } = this.props
    switch (viewType) {
      case TIMELINE:
        return this.getHorizontalTimelineContent()

      case LIST:
        return this.getListTimelineContent()

      default:
        console.warn('Unrecognized view type passed to timeline switcher')
    }
  }

  render() {
    const { viewType, viewSize, colorScheme } = this.props
    const showBorder = viewSize === SMALL || viewSize === MEDIUM || viewSize === LARGE
    // some classnames to change the available width
    const viewClassNames = classnames('view', `view--size-${viewSize}`, `view--type-${viewType}`, {
      'view--with-border': showBorder,
    })
    return (
      <ThemeContext.Provider value={colorScheme}>
        <div className={viewClassNames}>{this.getContent()}</div>
      </ThemeContext.Provider>
    )
  }
}
TimelineSwitcher.propTypes = {
  namespace: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  viewSize: PropTypes.string.isRequired,
}
TimelineSwitcher.defaultProps = {
  viewType: TIMELINE,
  viewSize: SMALL,
}
